import React, { useState, useEffect, useLayoutEffect, useRef, Fragment } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "../../Layout/Pages/LoginModal";
import Languages from "../../Layout/Pages/Languages";
import { useInquiryModal, useSigninModal } from "../useModal";
import { removeToCart, removeUserToState, addSelectedSevenDayaPass, addToLanguage } from "../../Reducers/authReducer";
import SearchBar from "material-ui-search-bar";
import Button from "@mui/joy/Button";
const { countries, zones } = require("moment-timezone/data/meta/latest.json");
import MenuIcon from "@mui/icons-material/Menu";
import Countries from "./Countries";
import Categories from "./Categories";
import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import Drawer from "@mui/joy/Drawer";
import List from "@mui/joy/List";
import ListItemButton from "@mui/joy/ListItemButton";
import ModalClose from "@mui/joy/ModalClose";
import CloseIcon from "@mui/icons-material/Close";
import Host from "../Host";
import { useFetchQuery, useDeleteMutation } from "../../services/cart";
import { useGetUserDataQuery } from "../../services/login";
import CartPage from "../../Pages/CartPage";
import Alert from "@mui/material/Alert";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import { useMediaQuery } from "react-responsive";
import ActiveCountries from "./ActiveCountries";
import Domains from "./Domains";
import GradeIcon from "@mui/icons-material/Grade";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import { getMetaByCountry } from "../../metaConfig";
const moment = require("moment-timezone");

const NAV_ITEMS = [
  { key: "cat1", label: "Health & Personal Care" },
  { key: "cat2", label: "Baby & Mom" },
  { key: "cat3", label: "Beauty & Cosmetics" },
  { key: "cat4", label: "Lifestyle & Sports" },
  { key: "cat5", label: "Gadgets & Electronics" },
  { key: "cat6", label: "Home & Kitchen" },
  { key: "cat7", label: "Pet Supplies" },
];

function CategoryNavItem({ item, columns, isOpen, isMobile, onOpen, onScheduleClose, onClose, fontFamily }) {
  const triggerRef = useRef(null);
  const panelRef = useRef(null);
  const [panelPos, setPanelPos] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    if (isMobile || !isOpen) return;

    function computePosition() {
      const trigger = triggerRef.current;
      if (!trigger) return;
      const GUTTER = 12;
      const rect = trigger.getBoundingClientRect();
      const panelWidth = panelRef.current?.offsetWidth || 280;

      let left = rect.left;
      const maxLeft = window.innerWidth - panelWidth - GUTTER;
      if (left > maxLeft) left = Math.max(GUTTER, maxLeft);

      setPanelPos({ top: rect.bottom + 8, left });
    }

    computePosition();
    window.addEventListener("resize", computePosition);
    window.addEventListener("scroll", computePosition, true);
    return () => {
      window.removeEventListener("resize", computePosition);
      window.removeEventListener("scroll", computePosition, true);
    };
  }, [isOpen, isMobile, columns]);

  const panelContent = (
    <div
      className={[
        "nav-dropdown-panel",
        isOpen ? "nav-dropdown-panel--open" : "",
        !isMobile ? "nav-dropdown-panel--portal" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      ref={panelRef}
      role="menu"
      style={!isMobile ? { top: panelPos.top, left: panelPos.left } : undefined}
      onMouseEnter={!isMobile ? () => onOpen(item.key) : undefined}
      onMouseLeave={!isMobile ? () => onScheduleClose() : undefined}
    >
      <div className="nav-dropdown-panel-inner">
        {columns.map((col, colIdx) => (
          <div className="nav-dropdown-col" key={colIdx}>
            {col.map((c, i) => (
              <Link
                key={i}
                role="menuitem"
                className="nav-dropdown-link"
                style={fontFamily}
                to={`/search/${c?.toLowerCase()}`}
                onClick={() => onClose()}
              >
                {c}
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className={`nav-dropdown ${isOpen ? "nav-dropdown--open" : ""}`}
      ref={triggerRef}
      onMouseEnter={!isMobile ? () => onOpen(item.key) : undefined}
      onMouseLeave={!isMobile ? () => onScheduleClose() : undefined}
    >
      <button
        type="button"
        className="nav-dropdown-trigger"
        aria-expanded={isOpen}
        onClick={(e) => {
          e.stopPropagation();
          isMobile && (isOpen ? onClose() : onOpen(item.key));
        }}
      >
        <span style={fontFamily}>{item.label}</span>
        <ExpandMoreIcon className="nav-dropdown-chevron" />
      </button>

      {isMobile ? panelContent : typeof document !== "undefined" && ReactDOM.createPortal(panelContent, document.body)}
    </div>
  );
}

function Header() {
  const { userId, userToken, userEmail, languageCode, countryCode, cartToken } = useSelector((state) => state.auth);
  const isLangaugeCode = languageCode ? languageCode : "en";
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { country } = useParams();
  const isMobcreen = useMediaQuery({
    query: "(min-width: 0px) and (max-width: 992px)",
  });

  useEffect(() => {
    const { title, description } = getMetaByCountry(countryCode);
    document.title = title;
    document.description = description;

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);

    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
  }, [countryCode]);

  const timeZoneToCountry = {};
  Object.keys(zones).forEach((z) => {
    const cityArr = z.split("/");
    const city = cityArr[cityArr.length - 1];
    timeZoneToCountry[city] = countries[zones[z].countries[0]].abbr;
  });
  let userCountryCode;
  if (Intl) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const userTimeZone = moment.tz.guess();
    const tzArr = userTimeZone?.split("/");
    const userCity = tzArr[tzArr.length - 1];
    userCountryCode = timeZoneToCountry[userCity] || "AE";
  }

  const thisHostname = window.location.hostname;

  const currentLanguage = Languages?.find((l) => l.code === i18next?.language);
  const liveDomain = Domains?.find((d) => d.domain?.includes(thisHostname));
  // const thisDomain = liveDomain?.code ? liveDomain?.code : userCountryCode === "US" ? "AE" : userCountryCode;
  const thisDomain = userCountryCode === "US" ? "AE" : userCountryCode;
  const attachDomain = countryCode ? countryCode : thisDomain;

  useEffect(() => {
    dispatch(
      addToLanguage({
        languageCode: i18next?.language ? i18next?.language : languageCode ? languageCode : "en",
        countryCode: country ? country?.toUpperCase() : attachDomain,
      })
    );
    document.body.dir = currentLanguage?.dir;
  }, []);

  const getCart = useFetchQuery(
    { userId: userId, cartToken: cartToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const fontFamily = {
    fontFamily: "Poppins, sans-serif",
    textAlign: "start",
  };

  const { isSigninModal, signinModal } = useSigninModal();
  function userLogout() {
    dispatch(removeToCart());
    dispatch(removeUserToState());
    dispatch(addSelectedSevenDayaPass({ selectedPass: false }));
    history.push("/");
  }

  function onClickLang(data) {
    localStorage.setItem("thisLanguageModel", true);
    const findLanguage = Languages?.find((l) => l.code === data);
    document.body.dir = findLanguage?.dir || "ltr";
    i18next.changeLanguage(data);
    dispatch(addToLanguage({ languageCode: data, countryCode: countryCode }));
    window.open(`/${data}`, "_self");
  }

  useEffect(() => {
    document.documentElement.lang = isLangaugeCode;
  }, [languageCode]);

  const currentLanguageName = Languages?.find((l) => l.code === isLangaugeCode);
  const [getSearchCountry, setSearchCountry] = useState("");
  const [isChnageCountry, setChangeCountry] = useState(false);

  function changeCountry() {
    setChangeCountry(true);
  }

  async function updateCountry(code) {
    dispatch(addToLanguage({ countryCode: code }));
    window.open(window.location.href, "_self");
  }

  function closeChangeCountry() {
    setChangeCountry(false);
  }

  const searchedCountries = Countries?.filter((l) => l.label?.toLowerCase()?.includes(getSearchCountry?.toLowerCase()));

  function fontFamilyFunc(code) {
    return {
      fontFamily: "Poppins, sans-serif",
    };
  }

  const [navSize, setnavSize] = useState("auto");
  const [getHomeHeaderMargin, setHomeHeaderMargin] = useState("0px");
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavSize("auto") : setnavSize("auto");
    window.scrollY > 10 ? setHomeHeaderMargin("0px") : setHomeHeaderMargin("0px");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const [getSearch, setSearch] = useState("");
  function headerSearch() {
    return (
      <SearchBar
        placeholder={t("search_product")}
        className="header-search-input"
        style={{
          margin: !isMobcreen ? "0px 20px" : 0,
          width: "100%",
          height: "40px",
          position: "relative",
        }}
        value={getSearch}
        onCancelSearch={() => setSearch("")}
        onChange={(newValue) => setSearch(newValue)}
        onRequestSearch={() => getSearch && history.push(`/search/${getSearch}`)}
        cancelOnEscape={true}
      />
    );
  }

  const [getcartDrawer, cartDrawer] = useState();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    cartDrawer(getcartDrawer);
  }, [getcartDrawer]);

  const stockTimerId = useRef();
  React.useEffect(() => {
    stockTimerId.current = setInterval(() => {
      if (!countryCode) {
        setChangeCountry(true);
      }
    }, 2000);
    return () => {
      clearInterval(stockTimerId.current);
    };
  }, [countryCode]);

  useEffect(() => {
    if (countryCode) {
      setChangeCountry(false);
    }
  }, [countryCode]);

  const list = (anchor) => (
    <Box
      className="side-dialogue-section"
      style={fontFamily}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List className="side-menu-list" style={fontFamily}>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/electronics`}>
          {t("electronics")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/televisions`}>
          {t("televisions")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/gaming and console`}>
          {t("gaming_and_console")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/speakers`}>
          {t("speakers")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/headphonesearphones`}>
          {t("headphones_earphones")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/home appliances`}>
          {t("home_appliances")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/music instruments`}>
          {t("music_instruments")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/entertainments`}>
          {t("entertainments")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/mobile phones`}>
          {t("mobile_phones")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/computers`}>
          {t("computers")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/laptops`}>
          {t("laptops")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/pc gaming`}>
          {t("pc_gaming")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/computer accessories`}>
          {t("computer_accessories")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/clothes`}>
          {t("clothes")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/watches`}>
          {t("watches")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/footwear`}>
          {t("footwear")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/office`}>
          {t("office")}
        </ListItemButton>
        <ListItemButton className="side-menu-item" component={Link} to={`/search/sports`}>
          {t("sports")}
        </ListItemButton>
      </List>
    </Box>
  );

  let thisCountry;
  if (countryCode === "UK") {
    thisCountry = "GB";
  } else {
    thisCountry = countryCode;
  }

  const [getLanguageModel, setLanguageModel] = useState(false);
  useEffect(() => {
    const thisLanguageModel = localStorage.getItem("thisLanguageModel");
    const hasArabic = navigator?.languages?.some((lang) => lang.startsWith("ar"));
    if (hasArabic && languageCode === "en") {
      if (!thisLanguageModel) {
        if (countryCode) {
          setLanguageModel(false);
        }
      }
    }
  }, [languageCode]);
  function closeLanguageModel() {
    setLanguageModel(false);
  }

  const [open, setOpen] = useState(null);
  const navRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  function clearScheduledClose() {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  }
  function openCategory(key) {
    clearScheduledClose();
    setOpen(key);
  }

  function scheduleCloseCategory() {
    clearScheduledClose();
    closeTimeoutRef.current = setTimeout(() => setOpen(null), 150);
  }

  function closeCategory() {
    clearScheduledClose();
    setOpen(null);
  }

  useEffect(() => {
    function handleOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpen(null);
      }
    }
    function handleEscape(e) {
      if (e.key === "Escape") setOpen(null);
    }
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleEscape);
      clearScheduledClose();
    };
  }, []);

  const location = useLocation();
  useEffect(() => {
    setOpen(null);
  }, [location?.pathname]);

  function columnsFor(key) {
    const data = Categories?.[0]?.[key];
    if (!data) return [[]];
    if (Array.isArray(data)) return [data];
    return Object.keys(data).map((k) => data[k]);
  }

  return (
    <>
      {getCart?.error?.originalStatus === 403 && (
        <div
          style={{
            position: "fixed",
            right: 0,
            laeft: 0,
            bottom: 0,
            zIndex: 999,
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Alert severity="error">Something went wrong. Please try after sometime.</Alert>
        </div>
      )}

      <Modal className="country-modal" show={getLanguageModel} onHide={closeLanguageModel} centered animation={false}>
        <Modal.Body style={{ padding: "20px" }}>
          <IconButton
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "10px",
              top: "10px",
              zIndex: 111,
            }}
            onClick={closeLanguageModel}
          >
            <CloseIcon className="Header-close-modal-icon" />
          </IconButton>
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: "center" }}>
                <p>Would you like to change your language?</p>
                <p style={{ fontFamily: "Poppins, sans-serif" }}>هل ترغب في تغيير لغتك؟</p>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={() => onClickLang("en")}
                  style={{ textTransform: "capitalize", margin: "0px 10px" }}
                >
                  <div>English</div>
                </Button>
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={() => onClickLang("ar")}
                  style={{
                    textTransform: "capitalize",
                    margin: "0px 10px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  <div>عربي</div>
                </Button>
              </div>
            </div>
            <br />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="country-modal cc-modal"
        show={isChnageCountry}
        onHide={closeChangeCountry}
        centered
        animation={false}
      >
        <Modal.Body style={{ padding: 0 }}>
          <IconButton className="cc-modal-close" onClick={closeChangeCountry}>
            <CloseIcon className="Header-close-modal-icon" />
          </IconButton>

          <div className="cc-modal-header">
            <img
              className="cc-modal-header-flag"
              loading="lazy"
              width="22"
              src={`https://flagcdn.com/w20/${countryCode?.toLowerCase()}.png`}
              srcSet={`https://flagcdn.com/w40/${countryCode?.toLowerCase()}.png 2x`}
              alt=""
            />
            <h5 className="cc-modal-title">{t("search_country")}</h5>
          </div>

          <div className="cc-modal-body">
            <div className="cc-search-wrap">
              <svg className="cc-search-icon" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
              <input
                onChange={(e) => setSearchCountry(e.target.value)}
                className="cc-search-input"
                placeholder={t("search_country")}
              />
            </div>

            <div className="cc-country-list">
              {searchedCountries?.map((item, i) => {
                const isActive = item.code === countryCode;
                return (
                  <button
                    type="button"
                    className={`cc-country-row ${isActive ? "cc-country-row--active" : ""}`}
                    disabled={isActive}
                    onClick={() => updateCountry(item.code)}
                    key={i}
                  >
                    <span className="cc-country-row-left">
                      <img
                        className="cc-country-flag"
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${item.code?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${item.code?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      <span className="cc-country-name">{item.label}</span>
                    </span>
                    {isActive && <GradeIcon className="cc-country-check" />}
                  </button>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="Header-page">
        <div
          className="Header-menu"
          style={{
            height: navSize,
            transition: "all 0.5s",
            background: Host?.headerBg,
          }}
        >
          <div className="container">
            <div className={`Header-menu-list2 Header-menu-list`} style={{ marginTop: getHomeHeaderMargin }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "0px 10px",
                }}
              >
                <div className="Header-menu-logoName">
                  <Link to={`/`}>
                    <img
                      src={Host?.domainLogo}
                      loading="lazy"
                      alt={Host?.domainName}
                      style={{ transition: "all 0.5s" }}
                    />
                  </Link>
                </div>
              </div>
              {!isMobcreen && headerSearch()}
              <div className="Header-menu-account">
                <LoginModal isSigninModal={isSigninModal} signinModal={signinModal} />
                <div className="Header-waller-connect1">
                  <Dropdown>
                    <MenuButton variant="light" className="Header-button-connect country-trigger">
                      <img
                        className="country-trigger-flag"
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${thisCountry?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${thisCountry?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      <div className="mobile-hide country-trigger-label" style={fontFamily}>
                        <span>{currentLanguageName?.code}</span>
                        <ExpandMoreIcon className="expand-style mobile-hide country-trigger-chevron" />
                      </div>
                    </MenuButton>
                    <Menu className="country-lang-menu">
                      <div className="country-lang-menu-label">{t("language") || "Language"}</div>
                      {Languages?.map((item, i) => {
                        const active = isLangaugeCode === item.code;
                        return (
                          <MenuItem
                            key={i}
                            onClick={() => onClickLang(item.code)}
                            disabled={active}
                            className={`lang-menu-item ${active ? "lang-menu-item--active" : ""}`}
                            style={fontFamily}
                          >
                            <span className="lang-menu-item-radio" aria-hidden="true" />
                            <span className="lang-menu-item-code">{item.code}</span>
                            <span className="lang-menu-item-name">{item.name}</span>
                          </MenuItem>
                        );
                      })}

                      <div className="country-lang-footer">
                        <div className="country-lang-footer-row">
                          <span className="country-lang-footer-label">{t("currency")}</span>
                          <span className="country-lang-footer-value">{userData?.contant?.currency}</span>
                        </div>
                        <div className="country-lang-footer-row">
                          <span className="country-lang-footer-label">{t("shipping_to")}</span>
                          <span className="country-lang-footer-value country-lang-footer-value--flag">
                            <img
                              loading="lazy"
                              width="18"
                              src={`https://flagcdn.com/w20/${thisCountry?.toLowerCase()}.png`}
                              srcSet={`https://flagcdn.com/w40/${thisCountry?.toLowerCase()}.png 2x`}
                              alt=""
                            />
                            {userData?.contant?.country}
                          </span>
                        </div>
                        <Button className="country-lang-change-btn" onClick={() => changeCountry()}>
                          {t("change_country")}
                        </Button>
                      </div>
                    </Menu>
                  </Dropdown>
                </div>
                {userEmail && userToken ? (
                  <div className="Header-waller-connect1">
                    <Dropdown>
                      <MenuButton variant="light" className="Header-button-connect account-trigger">
                        <span className="account-avatar">{userEmail?.charAt(0)?.toUpperCase()}</span>
                        <div className="mobile-hide account-trigger-label" style={fontFamily}>
                          <span>{t("account")}</span>
                          <ExpandMoreIcon className="expand-style mobile-hide account-trigger-chevron" />
                        </div>
                      </MenuButton>
                      <Menu className="account-menu">
                        <div className="account-menu-header">
                          <span className="account-menu-header-avatar">{userEmail?.charAt(0)?.toUpperCase()}</span>
                          <span className="account-menu-header-email">{userEmail}</span>
                        </div>
                        <MenuItem
                          key={"a3"}
                          className="account-menu-item"
                          style={fontFamily}
                          component={Link}
                          to={`/${isLangaugeCode}/account/overview`}
                        >
                          <AccountBoxOutlinedIcon className="account-menu-item-icon" />
                          <span>{t("My Account")}</span>
                        </MenuItem>
                        <MenuItem
                          key={"a1"}
                          className="account-menu-item"
                          style={fontFamily}
                          component={Link}
                          to={`/${isLangaugeCode}/account/orders`}
                        >
                          <LocalMallOutlinedIcon className="account-menu-item-icon" />
                          <span>{t("My Orders")}</span>
                        </MenuItem>
                        <div className="account-menu-divider" />
                        <MenuItem
                          key={"a5"}
                          className="account-menu-item account-menu-item--danger"
                          style={fontFamily}
                          onClick={userLogout}
                          component={Link}
                          to={`#`}
                        >
                          <ExitToAppOutlinedIcon className="account-menu-item-icon" />
                          <span>{t("signout")}</span>
                        </MenuItem>
                      </Menu>
                    </Dropdown>
                  </div>
                ) : (
                  <div className="Header-waller-connect1">
                    <Button
                      variant="light"
                      style={{
                        textTransform: "capitalize",
                        padding: "6px 8px",
                        border: "none",
                        borderRadius: "6px",
                        fontSize: "1rem",
                        color: "#fff",
                        display: "flex",
                        gap: "5px",
                      }}
                      disabled={!ActiveCountries?.includes(countryCode)}
                      aria-haspopup="true"
                      onClick={() => ActiveCountries?.includes(countryCode) && signinModal(true)}
                    >
                      <img src={"/Profile.svg"} style={{ width: "20px" }} />
                      <div className="mobile-hide">
                        <span style={fontFamily}>{t("Account")}</span>
                      </div>
                    </Button>
                  </div>
                )}
                <div className="Header-waller-connect1">
                  {[document.body.dir === "rtl" ? "left" : "right"].map((anchor) => (
                    <Button
                      variant="light"
                      style={{
                        textTransform: "capitalize",
                        padding: "6px 8px",
                        border: "none",
                        borderRadius: "6px",
                        fontSize: "1rem",
                      }}
                      key={anchor}
                      onClick={() => cartDrawer(anchor, true)}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          gap: "5px",
                        }}
                      >
                        <img src={"/Cart.svg"} style={{ width: "20px" }} />
                        <div className="mobile-hide">
                          <span style={fontFamily}>{t("cart")}</span>
                        </div>
                        <div
                          className="header-cart-value"
                          style={languageCode === "ar" ? { left: "-10px" } : { right: "-10px" }}
                        >
                          {getCart?.data?.cart?.length}
                        </div>
                      </div>
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isMobcreen && headerSearch()}

        <div
          className="Header-subnav"
          style={{
            background: Host?.subMenu,
          }}
        >
          <div className="container">
            <div className="Header-subnav-inner">
              <nav className="category-nav scroll-menu" ref={navRef}>
                {NAV_ITEMS.map((item) => (
                  <CategoryNavItem
                    key={item.key}
                    item={item}
                    columns={columnsFor(item.key)}
                    isOpen={open === item.key}
                    isMobile={isMobcreen}
                    onOpen={openCategory}
                    onScheduleClose={scheduleCloseCategory}
                    onClose={closeCategory}
                    fontFamily={fontFamily}
                  />
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>

      <React.Fragment>
        {[document.body.dir === "rtl" ? "right" : "left"].map((anchor) => (
          <Drawer
            className="side-menu-section side-scroll-menu"
            key={anchor}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                zIndex: 1,
                padding: "0px",
                textAlign: document.body.dir === "rtl" ? "left" : "right",
              }}
            >
              <ModalClose id="close-icon" sx={{ position: "initial" }} />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "6px 15px",
              }}
            >
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${thisCountry?.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${thisCountry?.toLowerCase()}.png 2x`}
              />
              <div style={{ padding: "5px 15px" }}>
                <small>{userData?.contant?.country}</small>
              </div>
            </div>
            {list(anchor)}
          </Drawer>
        ))}
      </React.Fragment>
      <CartPage getcartDrawer={getcartDrawer} cartDraweraa={cartDrawer} />
    </>
  );
}

function setMeta(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) {
    el.setAttribute("content", value);
  }
}

export default Header;
